export const ALGOLIA_APP_ID = process.env.NEXT_PUBLIC_ALGOLIA_APPLICATION_ID;
export const ALGOLIA_APP_KEY = process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_API_KEY;

export const ALGOLIA_INDEX_NAME =
  process.env.NEXT_PUBLIC_ALGOLIA_INDEX_NAME || '';
export const ALGOLIA_INDEX_DATE_ASC = `${ALGOLIA_INDEX_NAME}_date_asc`;
export const ALGOLIA_INDEX_NAME_QUERY_SUGGESTIONS =
  'prod_sympla_events_query_suggestions';
export const ALGOLIA_INDEX_EVENTS_SEARCH = 'prod_sympla_events-search';
export const ALGOLIA_INDEX_NAME_EVENTS_TOP10 = 'prod_sympla_events_top10';
export const ALGOLIA_INDEX_NAME_SPORTS = 'prod_sympla_sports';

export enum AlgoliaFilterAttributes {
  IS_ACCESSIBLE_FOR_FREE = 'is_accessible_for_free',
  TYPE = 'type',
  THEME = 'theme',
  SUBTHEME = 'subtheme',
  ORDER = 'order',
  DATE = 'date'
}

export const ALGOLIA_NUMBER_CARACTER = 3;

export const labelsAnalyticsTags = {
  recommendationSearch: 'recommendation_search',
  recommendationEvents: 'recommendation_events',
  popularSearch: 'popular_search',
  trendingEventsSearch: 'trending_events_search',
  eventsTop10: 'top_10_events',
  sportsPage: 'recommendation_sports_page',
  otherCities: 'recommendation_other_cities',
  lastCallCarousel: 'recommendation_lastcall_carousel',
  searchWithTerm: 'search_with_term',
  searchByDate: 'search_by_date',
  currentSearch: 'current_search',
  newProposalSearch: 'new_proposal_search'
};

export const deviceAnalyticsTags = {
  webMobileAndroid: 'web_mobile_android',
  webMobileIOS: 'web_mobile_ios',
  webMobile: 'web_mobile',
  webDesktop: 'web_desktop'
};

export type AnalyticsTag =
  | (typeof labelsAnalyticsTags)[keyof typeof labelsAnalyticsTags]
  | (typeof deviceAnalyticsTags)[keyof typeof deviceAnalyticsTags];
